<template>
    <div class="container">
        <page-header :title="title"></page-header>
        <div class="content">
            <div class="content-item" v-for="item in list" :key="item.efficacyTrackRemindId">
                <div class="title" :class="{'isRead': item.isRead}">待跟进提醒</div>
                <div class="main">
                    <div class="main-item">
                        <div class="main-left">预定跟进时间</div>
                        <div class="main-right">{{item.expectTrackTime}}</div>
                    </div>
                    <div class="main-item">
                        <div class="main-left">患者姓名</div>
                        <div class="main-right">{{item.userMemberName}}</div>
                    </div>
                    <div class="main-item">
                        <div class="main-left">患者编号</div>
                        <div class="main-right">{{item.userMemberId}}</div>
                    </div>
                </div>
                <div class="content-footer">
                    <van-button plain type="info" size="mini" @click="trackRecord(item)">写跟进信息</van-button>
                </div>
            </div>
        </div>
        <pagination :total="total" @pageChange="pageChange" v-if="total > 5"></pagination>
        <prev-page @back="back"></prev-page>
    </div>
</template>
<script>
    import { getTrackRemindList, remindIsRead } from '../../api/index'
    export default {
        data() {
            return {
                title: '跟进提醒',
                total: 0,
                searchData: {
                    pageNo: 1,
                    pageSize: 5,
                    createName: ''
                },
                list: []
            }
        },
        activated() {
            this.searchData.createName = this.$store.state.assistantNo
            this.getTrackRemindList()
        },
        methods: {
            getTrackRemindList() {
                getTrackRemindList(this.searchData).then(res => {
                    if(res.code == 0){
                        this.list = res.data.list
                        this.total = res.data.total
                    }
                })
            },
            // 分页
            pageChange(pageNo) {
                this.searchData.pageNo = pageNo
                this.getTrackRemindList()
            },
            back() {
                let data = {
                    // createName: this.$store.state.assistantNo
                }
                remindIsRead(data).then(res => {
                    if(res.code == 0){
                        this.$router.back()
                    }
                })
            },
            trackRecord(item) {
                console.log(item)
                this.$router.push({
                    path: '/trackRecord',
                    query: {
                        userNo: item.userNo,
                        userMemberId: item.userMemberId,
                        userMemberName: item.userMemberName,
                        currentId: 1
                    }
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .container {
        padding: 0 15px;
        padding-bottom: 90px;
        .content {
            .content-item {
                padding: 0 20px;
                background: #fff;
                margin-bottom: 10px;
                .title {
                    padding: 20px 0;
                    font-size: 18px;
                    font-weight: bold;
                    color: #E81C1C;
                }
                .isRead {
                    color: #333;
                }
                .main {
                    padding-bottom: 20px;
                    border-bottom: 1px solid #eee;
                    .main-item {
                        font-size: 14px;
                        display: flex;
                        align-items: center;
                        margin-bottom: 14px;
                        &:last-child {
                            margin-bottom: 0;
                        }
                        .main-left {
                            width: 120px;
                            color: #999;
                        }
                        .main-right {
                            flex: 1;
                            color: #333;
                            margin-bottom: -2px;
                        }
                    }
                }
                .content-footer {
                    display: flex;
                    justify-content: flex-end;
                    padding: 14px 0 20px 0;
                }
            }
        }
    }
</style>